import type {
  CompositionV2Filters,
  PostingFilters,
  SentimentV2Filters,
  TransitionsFiltersV2,
} from '@revelio/data-access';

import { type Filter, FilterType } from '../types/filters';

type CompanyKeys = 'rics_k10' | 'rics_k50' | 'rics_k400' | 'company';

type CompanyFilterProperties = Pick<CompositionV2Filters, CompanyKeys> &
  Pick<PostingFilters, CompanyKeys> &
  Pick<SentimentV2Filters, CompanyKeys> &
  Pick<TransitionsFiltersV2, CompanyKeys>;

export const getV2CompanyFilters = (
  filter: Filter
): CompanyFilterProperties => {
  if (filter.type !== FilterType.TREE) return {};

  return filter.selections.reduce<CompanyFilterProperties>((acc, selection) => {
    const lastSegment = selection.id.split('_').slice(-1)[0] ?? '';
    const numericStr = lastSegment.includes('.')
      ? (lastSegment.split('.').pop() ?? lastSegment)
      : lastSegment;
    const selectionId = parseInt(numericStr, 10);

    if (!Number.isFinite(selectionId)) {
      return acc;
    }

    if (selection.levelId === 'rics_k10') {
      return {
        ...acc,
        rics_k10: [...(acc.rics_k10 ?? []), selectionId],
      };
    }
    if (selection.levelId === 'rics_k50') {
      return {
        ...acc,
        rics_k50: [...(acc.rics_k50 ?? []), selectionId],
      };
    }
    if (selection.levelId === 'rics_k400') {
      return {
        ...acc,
        rics_k400: [...(acc.rics_k400 ?? []), selectionId],
      };
    }
    if (selection.levelId === 'company') {
      return {
        ...acc,
        company: [...(acc.company ?? []), selectionId],
      };
    }

    return acc;
  }, {});
};
